import React from 'react'

const MonthlyIncome = ({ value, handleMonthlyIncome}) => {
  return (
      <div className="form-check ms-2" key={value.income}>
          <input className="form-check-input" type="checkbox" id={value.income} onChange={() => handleMonthlyIncome(value.income)} value={value.income}  name='MONTHLY_INCOME' />
          <label className="form-check-label check-label" htmlFor={value.income}>
              {value.income}
          </label>
          {/* <hr></hr> */}
      </div>
      
  )
}

export default MonthlyIncome
